const googleApiKey = process.env.CI === 'true' ? 'GOOGLE_API_KEY' : process.env.NEXT_PUBLIC_GOOGLE_API_KEY
if (!googleApiKey) throw new Error('GOOGLE_API_KEY env variable is missing')

/** Google API key */
export const GOOGLE_API_KEY = googleApiKey